<template>
  <div>
    <v-navigation-drawer
        v-model="drawer"
        app
        dark
        src="@/assets/img/bgDrawer.jpg"
        temporary
    >
      <v-list>
        <v-list-item>
          <v-list-item-avatar>
            <img alt="Logo" src="@/assets/img/logo.png"/>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="title">BB-SMILE</v-list-item-title>
            <v-list-item-subtitle>BB-SMILE</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider/>

      <v-list dense>
        <v-list-item
            v-for="(item, i) in items"
            :key="i"
            link
            @click="$vuetify.goTo(item.link)"
        >
          <v-list-item-icon class="justify-center">
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="subtitile-1">{{
                item.text
              }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
        :class="{ expand: flat }"
        :color="color"
        :flat="flat"
        app
        class="px-15"
        dark
    >
      <v-toolbar-title>
        <v-img max-width="74px" src="@/assets/img/logo.png"/>
      </v-toolbar-title>
      <v-spacer/>
      <v-app-bar-nav-icon
          v-if="isXs"
          class="mr-4"
          @click.stop="drawer = !drawer"
      />
      <div v-else>
        <v-btn :class="{'underlinedButton': items[0].active}" text
               @click="$vuetify.goTo('#hero')">
          <span class="mr-2">Home</span>
        </v-btn>
        <v-btn :class="{'underlinedButton': items[1].active}" text
               @click="$vuetify.goTo('#features')">
          <span class="mr-2">Objectives</span>
        </v-btn>
        <v-btn :class="{'underlinedButton': items[2].active}" text
               @click="$vuetify.goTo('#services')">
          <span class="mr-2">Services</span>
        </v-btn>
        <v-btn :class="{'underlinedButton': items[3].active}" outlined rounded text
               @click="$vuetify.goTo('#contact')">
          <span class="mr-2">Contact us</span>
        </v-btn>
      </div>
    </v-app-bar>
  </div>
</template>

<style scoped>
.v-toolbar {
  transition: 0.6s;
}

.expand {
  height: 80px !important;
  padding-top: 10px;
}

.underlinedButton {
  text-decoration: #119DA4 solid underline;
  text-underline-position: under;
  transition: all 0.6s ease-out;
}

</style>

<script>
export default {
  data: () => ({
    drawer: null,
    isXs: false,
    items: [
      {icon: "mdi-home-outline", text: "Home", link: "#hero", active: true},
      {icon: "mdi-information-outline", text: "Objectives", link: "#features", active: false},
      {icon: "mdi-download-box-outline", text: "Services", link: "#services", active: false},
      {icon: "mdi-email-outline", text: "Contact us", link: "#contact", active: false},
    ],
  }),
  props: {
    color: String,
    flat: Boolean,
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    onResize() {
      this.isXs = window.innerWidth < 850;
    },
    handleScroll(event) {
      const offset = event.target.defaultView.pageYOffset

      let navIndex = 0
      if (offset > 500 && offset < 1000) {
        navIndex = 1
      } else if (offset > 1000 && offset < 1400) {
        navIndex = 2
      } else if (offset > 1400) {
        navIndex = 3
      }
      this.setUnderlineClass(navIndex)
    },
    setUnderlineClass(index) {
      this.items.forEach(item => item.active = false);
      let item = this.items[index];
      item.active = !item.active;
      this.$set(this.items, index, item);
    }
  },
  watch: {
    isXs(value) {
      if (!value) {
        if (this.drawer) {
          this.drawer = false;
        }
      }
    },
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, {passive: true});
  },
};
</script>
